import React from 'react';
import './MySafetyTag.css';
import { getAppEnv } from '../../../config/env';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const MySafetyTag = ({
  tooltipData = {
    heading: 'This bus has adopted the best safety standards',
    lists: [
      'Staff will always be wearing masks',
      'Buses will be sanitized after every journey',
      'Regular temperature checks will be held'
    ]
  }
}) => {
  return (
    <div className="mySafetyTag">
      <img
        className="tagImg lazyload"
        data-src={`${PUBLIC_URL}/static/public/mysafety-tag.png`}
        alt="mysafety tag"
      />
      {tooltipData && (
        <div className="mySafetyTag__toltip whiteText">
          <p className="latoBold font14 appendBottom10">
            {tooltipData.heading}
          </p>
          <ul className="mySafetyTag__list">
            {tooltipData.lists.map((item, index) => (
              <li className="font12" key={index}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MySafetyTag;
